import Component from "../abstracts/Component";

export default class CarouselComponent extends Component {
  get SELECTORS() {
    return {
      main: '[data-carousel="true"]:not(.slick-initialized)',
      prevArrow: "[data-prev-arrow]",
      nextArrow: "[data-next-arrow]"
    };
  }

  constructor() {
    super();
    this.main = $(this.SELECTORS.main);
    this.whatchRes = [];
  }

  importLibrary(elem) {
    this.moduleLoader.loadCarouselAndExecute(
      module => {
        this.initCarousels(elem);
        this.manageMobileCarousels();
      },
      error => {
        console.error("failed to load slick ", error.stack);
      }
    );
  }

  initCarousels(elem) {
    let selector = this.SELECTORS.main;
    let prevLabel = "";
    let nextLabel = "";
    if (document.querySelectorAll("[data-carousel]").length) {
      prevLabel = document.querySelector("[data-carousel]").dataset.prevLabel || "";
      nextLabel = document.querySelector("[data-carousel]").dataset.nextLabel || "";
    }
    let carousels = [];
    if (
      elem != null &&
      typeof elem != "undefined" &&
      document.getElementsByClassName(elem).length
    )
      carousels = document.getElementsByClassName(elem);
    else carousels = document.querySelectorAll(selector);

    for (let carousel of carousels) {
      const slides =
        typeof carousel.dataset.slides != "undefined"
          ? Number(carousel.dataset.slides)
          : 1;
      const visibleItemsMobile = this.checkMobileCarousel(carousel);
      const visibleItemsTablet =
        typeof carousel.dataset.visibleItemsMd != "undefined"
          ? Number(carousel.dataset.visibleItemsMd)
          : slides;
      const visibleItemsDesktop =
        typeof carousel.dataset.visibleItemsLg != "undefined"
          ? Number(carousel.dataset.visibleItemsLg)
          : slides;
      const isDots = carousel.dataset.dots === "true" ? true : false;
      const isFade = carousel.dataset.fade === "true" ? true : false;
      const isCenter = carousel.dataset.centerslick === "true" ? true : false;
      const isArrows = carousel.dataset.arrows === "true" ? true : false;
      const prevArrow =
        carousel.dataset.customarrows === "true"
          ? `<span class="fade-prev__outer"></span><button class="slick-prev slick-arrow" aria-label="${prevLabel}" type="button" style="">Previous</button><span class="fade-prev_inner"></span>`
          : `<span class="fade-prev__outer"></span><button type="button" class="w__slick-prev icon-slick-prev" aria-label="${prevLabel}" data-prev-arrow><i class="icon-slick-prev"></i></button><span class="fade-prev__inner"></span>`;
      const nextArrow =
        carousel.dataset.customarrows === "true"
          ? `<span class="fade-next__inner"></span><button class="slick-next slick-arrow" aria-label="${nextLabel}" type="button" style="">Next</button><span class="fade-next__outer"></span>`
          : `<span class="fade-next__inner"></span><button type="button" class="w__slick-next icon-slick-next" aria-label="${nextLabel}" data-next-arrow><i class="icon-slick-next"></i></button><span class="fade-next__outer"></span>`;
      const isAccessible = true;
      const isAutoplay = carousel.dataset.autoplay === "true" ? true : false;
      const isDraggable = carousel.dataset.draggable === "false" ? false : true;
      const isInfinite = carousel.dataset.infinite === "true" ? true : false;
      const autoplaySpeed =
        typeof carousel.dataset.autoplaySpeed != "undefined"
          ? carousel.dataset.autoplaySpeed
          : 3000;
      const slidesToScroll =
        typeof carousel.dataset.slidesToScroll != "undefined"
          ? Number(carousel.dataset.slidesToScroll)
          : 1;
      const slidesToScrollMobile =
        typeof carousel.dataset.slidesToScrollMobile != "undefined"
          ? Number(carousel.dataset.slidesToScrollMobile)
          : 1;
      const isVariableWidth =
        carousel.dataset.variablewidth === "true" ? true : false;
      const centerPadding =
        carousel.dataset.centerpadding != undefined
          ? carousel.dataset.centerpadding
          : "";
      const customPaging = function(slider, i) {
        return $(
          '<button><i class="icon-slider-bullet"></i><i class="icon-slider-bullet-active"></i></button>'
        );
      };

      let options = {
        dots: isDots,
        arrows: isArrows,
        prevArrow: prevArrow,
        nextArrow: nextArrow,
        infinite: isInfinite,
        centerMode: isCenter,
        centerPadding: centerPadding,
        autoplay: isAutoplay,
        autoplaySpeed: autoplaySpeed,
        accessibility: isAccessible,
        draggable: isDraggable,
        slidesToShow: slides,
        slidesToScroll: slidesToScroll,
        slidesToScrollMobile: slidesToScrollMobile,
        fade: isFade,
        variableWidth: isVariableWidth,
        customPaging: customPaging
      };

      let responsiveArray = this.setResponsiveArray(
        visibleItemsMobile,
        visibleItemsTablet,
        visibleItemsDesktop,
        slidesToScrollMobile
      );

      options = $.extend({}, options, {
        responsive: responsiveArray
      });

      const editMode = carousel.dataset.editMode === "true" ? true : false;
      if (editMode) return false;

      const onlyMobile = carousel.dataset.onlyMobile === "true" ? true : false;

      let checkItems = slides;
      if (window.matchMedia("(max-width:767px)").matches || onlyMobile)
        checkItems = visibleItemsMobile;
      else if (window.matchMedia("(max-width:1280px)").matches)
        checkItems = visibleItemsTablet;
      $(carousel).on("init", e => {
        this.animateArrows(carousel);
        this.$emit(this.$customEvents.CAROUSEL.initCarousel, {
          carousel: carousel
        });
        carousel.classList.contains("sh-cat__carousel") &&
          this.detectZoom(carousel);
        carousel.classList.contains("sh-cat__carousel") &&
          this.reorderArrows(carousel);
      });
      if (
        carousel.children.length < checkItems ||
        !$(carousel).is(":visible")
      ) {
        this.log("Carousel not triggered");
      } else if (window.matchMedia("(max-width:767px)").matches && onlyMobile) {
        $(carousel).slick(options);
        this.log("Carousel Triggered");
      } else if (!onlyMobile) {
        $(carousel).slick(options);
        this.log("Carousel Triggered");
      }
    }
  }

  setResponsiveArray(
    visibleItemsMobile,
    visibleItemsTablet,
    visibleItemsDesktop,
    slidesToScrollMobile
  ) {
    let responsiveArray = [];
    if (visibleItemsMobile == "unslick") {
      responsiveArray.push({
        breakpoint: 768,
        settings: visibleItemsMobile
      });
    } else {
      responsiveArray.push({
        breakpoint: 768,
        settings: {
          slidesToShow: visibleItemsMobile,
          slidesToScroll: slidesToScrollMobile
        }
      });
    }
    if (visibleItemsTablet == "unslick") {
      responsiveArray.push({
        breakpoint: 1280,
        settings: visibleItemsTablet
      });
    } else {
      responsiveArray.push({
        breakpoint: 1280,
        settings: {
          slidesToShow: visibleItemsTablet
        }
      });
    }
    //set only if not a carousel in desktop else use default configs
    if (visibleItemsDesktop == "unslick") {
      responsiveArray.push({
        breakpoint: 60000,
        settings: visibleItemsDesktop
      });
    }
    return responsiveArray;
  }

  animateArrows(carousel) {
    let prevArrow = carousel.querySelector(this.SELECTORS.prevArrow);
    if (prevArrow) {
      prevArrow.addEventListener("mousedown", () => {
        prevArrow.classList.remove("transition");
      });
      prevArrow.addEventListener("click", () => {
        prevArrow.classList.add("transition");
      });
    }
    let nextArrow = carousel.querySelector(this.SELECTORS.nextArrow);
    if (nextArrow) {
      nextArrow.addEventListener("mousedown", () => {
        nextArrow.classList.remove("transition");
      });
      nextArrow.addEventListener("click", () => {
        nextArrow.classList.add("transition");
      });
    }
  }

  checkMobileCarousel(carousel) {
    if (carousel.classList.contains("not-mobile")) {
      return "unslick";
    } else {
      if (typeof carousel.dataset.visibleItemsXs !== "undefined") {
        return Number(carousel.dataset.visibleItemsXs);
      } else {
        return carousel.dataset.slides;
      }
    }
  }

  bindEvents() {
    this.$on(this.$customEvents.MODAL_EVENTS.afterOpen, () => {
      console.log("afterOpen Modal");
      let carouselsIntoVex = document
        .querySelector(".vex")
        .querySelectorAll('[data-carousel="in-vex"]');
      if (carouselsIntoVex.length > 0) {
        for (let carouselInVex of carouselsIntoVex) {
          carouselInVex.dataset.carousel = "true";
        }
        this.initCarousels();
      }
    });

    this.$on(this.$customEvents.CAROUSEL.triggerCarousel, data => {
      this.importLibrary(data.payload);
    });
    window.addEventListener("resize", () => {
      this.detectZoom();
    });
  }

  manageMobileCarousels() {
    let carousels = document.querySelectorAll(".slick-slider");
    for (let carousel of carousels) {
      let slickDots = $(carousel).find(".slick-dots");
      if (slickDots.length) {
        if (
          $(slickDots).children("li").length > 6 &&
          $(slickDots).parent(".slick-dots-container").length == 0
        ) {
          $(slickDots).wrap("<div class='slick-dots-container'></div>");
          $(slickDots)
            .find("li")
            .each(function(index) {
              $(this).addClass("dot-index-" + index);
            });
          if (slickDots.children("li").length > 14) {
            $(slickDots).css("transform", "translateX(80px)");
          } else {
            $(slickDots).css("transform", "translateX(40px)");
          }
          $(carousel).on("beforeChange", function(
            event,
            slick,
            currentSlide,
            nextSlide
          ) {
            let currentTranslateX = parseInt(
              $(this)
                .find(".slick-dots")
                .css("transform")
                .split(",")[4]
            );
            let transformCount = 0;
            if (
              !$(this)
                .find("ul.slick-dots li:first-child")
                .hasClass("slick-active") &&
              !$(this)
                .find("ul.slick-dots li:nth-child(2)")
                .hasClass("slick-active") &&
              !$(this)
                .find("ul.slick-dots li:last-child")
                .hasClass("slick-active") &&
              !$(this)
                .find("ul.slick-dots li:nth-last-child(2)")
                .hasClass("slick-active")
            ) {
              if (nextSlide > currentSlide) {
                if (
                  !$(this)
                    .find("ul.slick-dots li:nth-last-child(3)")
                    .hasClass("slick-active")
                ) {
                  transformCount = currentTranslateX - 40;
                  $(this)
                    .find("ul.slick-dots")
                    .css("transform", "translateX(" + transformCount + "px)");
                }
              } else {
                if (
                  !$(this)
                    .find("ul.slick-dots li:nth-child(3)")
                    .hasClass("slick-active")
                ) {
                  transformCount = currentTranslateX + 40;
                  $(this)
                    .find("ul.slick-dots")
                    .css("transform", "translateX(" + transformCount + "px)");
                }
              }
            }
          });
        }
      }
    }
  }

  detectZoom(carousel) {
    const zoom = Math.round(window.devicePixelRatio * 100);
    const prev = carousel
      ? carousel.querySelector(this.SELECTORS.prevArrow)
      : document.querySelector(".w-shortcut-category .w__slick-prev");
    const next = carousel
      ? carousel.querySelector(this.SELECTORS.nextArrow)
      : document.querySelector(".w-shortcut-category .w__slick-next");
    if(zoom >= 200 && prev && next) {
      prev.classList.add("visible");
      next.classList.add("visible");
    } else if(zoom < 200 && prev && next) {
      prev.classList.remove("visible");
      next.classList.remove("visible");
    }
    $(carousel).on("breakpoint", event => {
      const prev = carousel
        ? event.target.querySelector(this.SELECTORS.prevArrow)
        : event.target.querySelector(".w-shortcut-category .w__slick-prev");
      const next = carousel
        ? event.target.querySelector(this.SELECTORS.nextArrow)
        : event.target.querySelector(".w-shortcut-category .w__slick-next");
      if(zoom >= 200 && prev && next) {
        prev.classList.add("visible");
        next.classList.add("visible");
      } else if(zoom < 200 && prev && next) {
        prev.classList.remove("visible");
        next.classList.remove("visible");
      }
    });
  }

  reorderArrows(carousel) {
    const nextArrow = carousel.querySelector(this.SELECTORS.nextArrow);
    const nextArrowPre = nextArrow ? nextArrow.previousElementSibling : null;
    const nextArrowPost = nextArrow ? nextArrow.nextElementSibling : null;
    const prevArrow = carousel.querySelector(this.SELECTORS.prevArrow);

    if (prevArrow && nextArrow) {
      // Insert nextArrowPre after prevArrow
      if (nextArrowPre && nextArrowPre !== prevArrow) {
        prevArrow.parentNode.insertBefore(nextArrowPre, prevArrow.nextSibling);
      }
      // Insert nextArrow after prevArrow (or after nextArrowPre if it was just moved)
      prevArrow.parentNode.insertBefore(nextArrow, prevArrow.nextSibling);
      // Insert nextArrowPost after nextArrow
      if (nextArrowPost) {
        nextArrow.parentNode.insertBefore(nextArrowPost, nextArrow.nextSibling);
      }
    }
  }

  render() {
    super.render();
    if (document.querySelectorAll("[data-carousel]").length) {
      this.importLibrary();
    }
    this.bindEvents();
  }
}
